<template>
  <div class="contact-tile-fi">
    <div class="contact-tile-fi__contact-details-head">
      <div class="contact-tile-fi__image-container">
        <cloud-image-fi
          class="contact-tile-fi__image"
          field-name="image"
        />
      </div>
      <single-line-text-field-fi
        class="contact-tile-fi__name fi-block"
        field-name="name"
      />
      <single-line-text-field-fi
        class="contact-tile-fi__role fi-block"
        field-name="role"
      />
    </div>
    <contact-details-fi class="contact-tile-fi__contact-details" />
  </div>
</template>

<script setup lang="ts">
import { CloudImageFi, SingleLineTextFieldFi } from 'atoms';

import ContactDetailsFi from '@/components/contact-details-fi/ContactDetailsFi.vue';

defineOptions({ name: 'ContactTileFi' });
</script>

<style src="./contact-tile-fi-unscoped" />

<style scoped src="./contact-tile-fi" />
